import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const AVOID_BUTTON_WITH_ICON_HEIGHT = 120;
const ICON_SIZE = 40;
const style = () => {
    const { colorBgInteractiveActive, borderRadius3, space4, colorIconLight, colorText } = theme();
    return StyleSheet.create({
        button: {
            alignItems: "flex-start",
            backgroundColor: colorBgInteractiveActive,
            borderRadius: borderRadius3,
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: AVOID_BUTTON_WITH_ICON_HEIGHT,
            paddingHorizontal: space4,
            paddingVertical: space4,
        },
        container: {
            flex: 1,
        },
        icon: {
            color: colorIconLight,
            fontSize: ICON_SIZE,
            height: ICON_SIZE,
            lineHeight: ICON_SIZE,
            minHeight: ICON_SIZE,
            minWidth: ICON_SIZE,
            width: ICON_SIZE,
        },
        text: {
            color: colorText,
            padding: 0,
        },
    });
};
export { style };
